export default __webpack_public_path__ + "static/media/030307202139102.52af09f3.png";